import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { WidgetService } from '../../../services/widget/widget.service';
import { CommonService } from '../../../services/common/common.service';

@Component({
  selector: 'public-graph',
  templateUrl: './public-graph.component.html',
  styleUrls: ['./public-graph.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PublicGraphComponent implements OnInit {
  @Input('wigetData') wigetData: any;

  graphSource: any = {};
  graphData: any = { timeFrame: "", kpiType: "", fetchDataFor: "", dataFilter: "", events: "" };
  firstDay = "";
  lastDay = "";
  
  constructor(
    private widgetService: WidgetService,
    private commonService: CommonService
  ) { }

  ngOnInit() {
    this.graphSource.dataFilter = this.wigetData.dataFilter;
    this.graphSource.kpiType = this.wigetData.kpiType;
    this.graphSource.fetchDataFor = this.wigetData.fetchDataFor;
    this.graphSource.showDataByOperationalHours = this.wigetData.showDataByOperationalHours;


    //set the date in from and to
    let dateObj = this.commonService.convertDate(this.wigetData.dateType, this.wigetData.from, this.wigetData.to);
    this.wigetData.from = dateObj.firstDay;
    this.wigetData.to = dateObj.lastDay;
    
    this.graphSource.from = this.wigetData.from;
    this.graphSource.to = this.wigetData.to;
    this.graphSource.timeFrame = this.wigetData.groupByTimeFrame;
    this.firstDay = this.commonService.getUTCToLocalDate(this.wigetData.from, 1);
    this.lastDay = this.commonService.getUTCToLocalDate(this.wigetData.to, 1);

    //add extra data
    this.graphSource.udf = { axisConfig: this.wigetData.axisConfig };
    
    this.widgetService.kpiPublicData(this.graphSource).subscribe(
      res => {
        this.graphData = res;
      },
      (err) => { }
    );
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/graphs/public-graph/public-graph.component.ts